
  $(window).scroll(function(){
    var scroll_value = $(window).scrollTop();
    if(scroll_value > 50){
      $('body').addClass('header-fixed');
    }else{
      $('body').removeClass('header-fixed');
    }
  });

  //$(window).on("load resize orientationchange", function(){
    /*if(window.innerWidth >= 798){
      if($('.grid-5 .layout--grid').children().length > 5){
        $('.grid-5 .layout--grid').flickity({
          
          cellAlign: 'center',
          wrapAround: true,
          contain: true,
          pageDots: false,
          arrowShape: arrowShape,
          prevNextButtons:true
        });
      }
    }
    else
    {
      if($('.grid-5 .layout--grid').children().length > 3){
        $('.grid-5 .layout--grid').flickity({
          
          cellAlign: 'center',
          wrapAround: true,
          contain: true,
          pageDots: false,
          arrowShape: arrowShape,
          prevNextButtons:true
        });
      }
    }*/
    
    
  //});


$(document).ready(function(){
  $('[data-variant-selector]').on('change', function(){
    var imgid = $(this).find(':selected').attr('data-image-id');
    var ind = $('.product-gallery__main').find('.product-gallery__image[data-id="'+imgid+'"]').attr('data-index');
    console.log(ind)
    $('.product-gallery__main').flickity( 'select', ind );
  });
});

$('.slideshow-classic.image-slideshow').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
});
    
$('.grid-5 .layout--grid').slick({
      dots: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow:4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow:1,
            centerMode:true,
            centerPadding:'80px',
            slidesToScroll: 1
          }
        }
      ]
    });



$('.products-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
  
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow:4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow:2,
          slidesToScroll: 1
        }
      }
    ]
  });

$('#shopify-section-template--16676510695659__c24b8195-90ab-4cea-84a8-feadf734811c .products-slider').slick('unslick');
$('#shopify-section-template--16676510695659__c24b8195-90ab-4cea-84a8-feadf734811c .products-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow:4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1
        }
      }
    ]
  });

$(window).on("load resize orientationchange", function() {
  var i = $(".page-artistcustom .blog-posts .container:last-child");
  $(window).width() > 980 ? i.hasClass("slick-initialized") && i.slick("unslick") : i.hasClass("slick-initialized") || i.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: !0,
    centerPadding: "50px",
    mobileFirst: !0,
    responsive: [{
      breakpoint: 980,
      settings: "unslick"
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerPadding: "100px"
      }
    }]
  });

//   $('.products-slider.layout--slider').flickity({
//     // options
//     cellAlign: 'left',
//     wrapAround: true,
//     contain: true,
//     pageDots: false,
//     arrowShape: arrowShape
//   });
  
  

  

  function gallaryImageClick(){
    var $carousel = $('.announcement-slider').flickity({
      cellAlign: 'center',
      wrapAround: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: true,
      draggable: false,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false
    });
    $carousel.flickity('playPlayer');
  }
  gallaryImageClick();
  $('.announcement-slider').on('click touchend', function(){
    gallaryImageClick();
  });

});

// }));


$(document).ready(function(){
  
  var btn = $('.back_to_top');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 500) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '2000');
    });

  var touchmoved;

  $(document).on('touchend', '.products-slider .product-wrap, .boost-pfs-filter-product-item-inner', function(e){
    if( touchmoved != true) {

      if( $(this).hasClass('hovered') ){
        $(this).removeClass('hovered');
        return true;
      }else{
        $('.product-wrap, .boost-pfs-filter-product-item-inner').removeClass('hovered');
        $(this).addClass('hovered')
        return false;
      }

    }
  }).on('touchmove', function(e){
    touchmoved = true; 
  }).on('touchstart', function(e){
    touchmoved = false;   
  });



  function i() {
    $(".product-thumbnail").each(function() {
      $(".product-thumbnail").css("height", "auto");
      var e = -1;
      $(".product-thumbnail").each(function() {
        var t = $(this).outerHeight();
        e = t > e ? t : e
      }), $(".product-thumbnail").css("height", e)
    })

    $(".boost-pfs-filter-product-bottom").each(function() {
      $(".boost-pfs-filter-product-bottom").css("height", "auto");
      var e = -1;
      $(".boost-pfs-filter-product-bottom").each(function() {
        var t = $(this).outerHeight();
        e = t > e ? t : e
      }), $(".boost-pfs-filter-product-bottom").css("height", e)
    })

    $(".boost-pfs-filter-product-item-image").each(function() {
      $(".boost-pfs-filter-product-item-image").css("height", "auto");
      var e = -1;
      $(".boost-pfs-filter-product-item-image").each(function() {
        var t = $(this).outerHeight();
        e = t > e ? t : e
      }), $(".boost-pfs-filter-product-item-image").css("height", e)
    })



  }

  setTimeout(function(){
    if(window.innerWidth >= 768){
      if($('[data-box-type="YouMayLike"] .limespot-recommendation-box-grid').children().length > 5){
        $('[data-box-type="YouMayLike"] .limespot-recommendation-box-grid').flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          contain: false,
          pageDots: false,
          arrowShape: arrowShape
        });  	
      }
      if($('[data-box-type="RecentViews"] .limespot-recommendation-box-grid').children().length > 5){
        $('[data-box-type="RecentViews"] .limespot-recommendation-box-grid').flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          contain: false,
          pageDots: false,
          arrowShape: arrowShape
        });  	
      }
    }
    else{
      if($('[data-box-type="YouMayLike"] .limespot-recommendation-box-grid').children().length > 2){
        $('[data-box-type="YouMayLike"] .limespot-recommendation-box-grid').flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          contain: false,
          pageDots: false,
          arrowShape: arrowShape
        });  	
      }
      if($('[data-box-type="RecentViews"] .limespot-recommendation-box-grid').children().length > 2){
        $('[data-box-type="RecentViews"] .limespot-recommendation-box-grid').flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          contain: false,
          pageDots: false,
          arrowShape: arrowShape
        });  	
      }
    }
    
//     $(".ls-info-wrap .ls-title").each(function() {
//       $(".ls-info-wrap .ls-title").css("height", "auto");
//       var e = -1;
//       $(".ls-info-wrap .ls-title").each(function() {
//         var t = $(this).outerHeight();
//         e = t > e ? t : e
//       }), $(".ls-info-wrap .ls-title").css("height", e)
//     })
  },2000);

  jQuery(window).on("load resize orientationchange", function(){
  	setTimeout(function(){ i()},500)
  });

  $(window).on('load resize', function(){
    if ($(window).width() < 799) {
      $('.footer__menu .footer__heading+ul').hide();
    }
    else {
      $('.footer__menu .footer__heading+ul').show();
    }
  });

  $('.footer__menu .footer__heading').click(function(){
    $(this).toggleClass('up');
    $(this).next('ul').slideToggle();
  })
  //i(), jQuery(window).on("load resize orientationchange", i());

  setTimeout(function(){
    var image_height = $('.products-slider .product-image__wrapper').outerHeight();
    var top_pos= (image_height/2) - 22; 
    $('.products-slider .flickity-button, .products-slider .slick-arrow').css({
      'top': top_pos + 'px',
      'margin-top':'0px'
    });
  },100)
  setTimeout(function(){
    var image_height1 = $('.limespot-recommendation-box-grid .ls-image-wrap').outerHeight();
    var top_pos1= (image_height1/2) - 22; 

    setInterval(function () {
      $('.ls-li-overlay-container .ls-add-to-cart-wrap').css('top', image_height1 + 'px');
    }, 300);

    $('.limespot-recommendation-box-grid .flickity-button').css({
      'top': top_pos1 + 'px',
      'margin-top':'0px'
    });

  },1500);
  
  jQuery(window).on("load resize orientationchange", function(){
  	var image_height = $('.products-slider .product-image__wrapper').outerHeight();
    var top_pos= (image_height/2); 
    $('.products-slider .flickity-button, .products-slider .slick-arrow').css({
      'top': top_pos + 'px',
      'margin-top':'0px'
    });
    
    var image_height1 = $('.limespot-recommendation-box-grid .ls-image-wrap').outerHeight();
    var top_pos1= (image_height1/2) - 22; 
    $('.limespot-recommendation-box-grid .flickity-button').css({
      'top': top_pos1 + 'px',
      'margin-top':'0px'
    });
  })
  
  
})
//# sourceMappingURL=/s/files/1/0117/4483/7728/t/84/assets/custom.js.map?v=1637325944

// $( document ).ready(function() {
//    $('.products-slider').css('opacity',0);
//    setTimeout(function() {
//      $('.products-slider.flickity-enabled').css('opacity',1);
//    },500);
// });

// $.get("https://ipinfo.io", function(response) {
//     var country = response.country;
//   var region = response.region;
//    console.log(country, region);
//     if( country == 'GB' || region == "England" ){
//       setTimeout(function() {
//         $('.shipping-uk-msg').addClass('show');  
//       },1000)
      
//     }
// }, "json")

fetch('https://api.ipregistry.co/?key=tryout')
  .then(function (response) {
      return response.json();
  })
  .then(function (payload) {
    // console.log('payload', payload.location.country);
      //console.log('hello', payload.location.country.name)
      if( payload.location.country.name == "United Kingdom" ){
        $(() => {
          const checkDiv = setInterval(() => {
            if($('.shipping-uk-msg').length > 0) {
              $('.shipping-uk-msg').addClass('show');
            } 
          }, 100); // check after 100ms every time
        });
      }
  });

$(window).on("load", function() {
  setTimeout(function() {
    $('.flickity-prev-next-button').removeClass('disable');
    $('.featured-collection-section .section').removeClass('disable');
    $('.slideshow-section .section').removeClass('disable');
    //  $('.featured-collection-section  section').removeClass('disable');
  },2000);
});